import React from 'react';
import PropTypes from 'prop-types';
import _, {isEmpty} from 'lodash';

import ReportOrderToGoogleAnalytics4 from "./ReportOrderToGoogleAnalytics4";
import ReportOrderToFacebook from "./ReportOrderToFacebook";
import CatchErrors from "../Utility/CatchErrors";
import ReportToGoogle from "./ReportToGoogle";

export default function ReportOrderCompleteApp({
  order, orderedItems, groupCollection, googleTagManager = {disabled: true},
  debugReporting = false,
  ...props
}) {
  if (!order?.id)
    return null;

  return (
    <CatchErrors invisible={true}>

      <CatchErrors invisible={true}>
        <ReportToGoogle
          order={order}
          orderedItems={orderedItems}
          groupCollection={groupCollection}
          googleTagManager={googleTagManager}
          debugReporting={debugReporting}
        />
      </CatchErrors>

      <CatchErrors invisible={true}>
        <ReportOrderToFacebook
          order={order}
          orderedItems={orderedItems}
          groupCollection={groupCollection}
        />
      </CatchErrors>
    </CatchErrors>
  );
}
